import { PcfraPerson, Person } from '../types/people';

/**
 * Ensures that any numerical components of a string are sorted by their numerical value
 * i.e. 1, 2, 3 as opposed to 1, 10, 100
 * */
export const getPartiallyNumericSortKey = (value: string) =>
  // Replaces each number value with a single character by converting the value to a char code with a minimum of 65 ('A')
  // The char is prefixed with "0" to ensure the full replacement will be sorted before a compared value that does not contain numbers
  value.replace(/\d+/g, (match) => `0${String.fromCharCode(parseInt(match) + 64)}`);

export const getPersonNameSortKey = ({ forename, surname }: Person | PcfraPerson) =>
  [surname, forename].join();
